import { useState, useEffect, useRef } from 'react';
import { useApp } from '../context/AppContext';
import { useI18n } from '../context/I18nContext';

export default function CollabPanel() {
  const { collabMessages, setCollabOpen, sendChat } = useApp();
  const { t } = useI18n();
  const [text, setText] = useState('');
  const panelRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        setCollabOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [setCollabOpen]);

  const chatMessages = collabMessages;

  const handleSend = () => {
    if (!text.trim()) return;
    sendChat(text);
    setText('');
  };

  return (
    <div ref={panelRef} className="collab-panel show">
      <div className="collab-header">
        <h4>{t('teamChat')}</h4>
        <button onClick={() => setCollabOpen(false)}>&times;</button>
      </div>
      <div className="collab-messages">
        {chatMessages.map((msg, i) => (
          <div key={i} className="collab-message">
            <span className="collab-name">{msg.data.name}</span>
            <span className="collab-text">{msg.data.text}</span>
            <span className="collab-time">
              {new Date(msg.data.time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </span>
          </div>
        ))}
      </div>
      <div className="collab-input">
        <input
          type="text"
          placeholder={t('typeAMessage')}
          value={text}
          onChange={e => setText(e.target.value)}
          onKeyPress={e => e.key === 'Enter' && handleSend()}
        />
        <button onClick={handleSend}>{t('send')}</button>
      </div>
    </div>
  );
}
